
"use client";

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ReferenceLine } from 'recharts';
import HelpTooltip from "@/components/ui/HelpTooltip";

interface EvolutionPoint {
    date: string;
    score: number;
}

interface PerformanceEvolutionChartProps {
    data: EvolutionPoint[];
}

export default function PerformanceEvolutionChart({ data }: PerformanceEvolutionChartProps) {
    // If we have no data or little data, handle gracefully?
    // Parent should probably handle the "no exams" state.

    return (
        <Card className="col-span-1 lg:col-span-2">
            <CardHeader>
                <CardTitle className="text-lg flex items-center">
                    Performance Evolution
                    <HelpTooltip content="Tracks your exam scores over time. Look for an upward trend. The dotted red line represents the 55% passing threshold." />
                </CardTitle>
                <CardDescription>Your score trajectory over time</CardDescription>
            </CardHeader>
            <CardContent>
                <div className="h-[300px] w-full">
                    <ResponsiveContainer width="100%" height="100%">
                        <LineChart data={data} margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" opacity={0.2} />
                            <XAxis dataKey="date" fontSize={12} tickLine={false} axisLine={false} minTickGap={30} />
                            <YAxis domain={[0, 100]} fontSize={12} tickLine={false} axisLine={false} tickFormatter={(v) => `${v}%`} />
                            <Tooltip
                                contentStyle={{ backgroundColor: 'hsl(var(--card))', borderRadius: '8px', border: '1px solid hsl(var(--border))' }}
                                formatter={(value: number) => [`${value.toFixed(1)}%`, 'Score']}
                            />
                            <ReferenceLine y={55} stroke="hsl(var(--destructive))" strokeDasharray="3 3" label={{ value: 'Pass (55%)', position: 'insideTopRight', fill: 'hsl(var(--destructive))', fontSize: 12 }} />
                            <Line
                                type="monotone"
                                dataKey="score"
                                stroke="hsl(var(--primary))"
                                strokeWidth={2}
                                dot={{ r: 4, fill: 'hsl(var(--background))', strokeWidth: 2 }}
                                activeDot={{ r: 6 }}
                            />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            </CardContent>
        </Card>
    );
}
